import React, { useState } from 'react';
import { Patient } from '../services/patientsService';
import ServiceStatusIcons from './ServiceStatusIcons';
import { useIsMobile } from '../hooks/useIsMobile';

const Field: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
  <div>
    <div style={{ fontSize: 12, fontWeight: 600, color: '#6b7280', marginBottom: 4, textTransform: 'uppercase' }}>
      {label}
    </div>
    <div style={{ fontSize: 15, color: '#1f2937' }}>{children}</div>
  </div>
);

const formatDate = (value?: string | null) =>
  value ? new Date(value).toLocaleDateString('es-ES') : '-';

const formatDateTime = (value?: string | null) =>
  value
    ? new Date(value).toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '-';

const genderLabel = (gender?: string) =>
  gender === 'male' ? 'Masculino' : gender === 'female' ? 'Femenino' : gender === 'other' ? 'Otro' : '-';

const PatientInfoDetails: React.FC<{ patient: Patient }> = ({ patient }) => {
  const isMobile = useIsMobile();
  const [expanded, setExpanded] = useState(false);
  const open = !isMobile || expanded;

  return (
    <div style={{ marginTop: 24 }}>
      {isMobile && (
        <button
          onClick={() => setExpanded((v) => !v)}
          aria-expanded={expanded}
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: '#fff',
            border: '1px solid #e5e7eb',
            borderRadius: 8,
            padding: '12px 16px',
            fontSize: 14,
            fontWeight: 600,
            color: '#374151',
            cursor: 'pointer',
          }}
        >
          <span>{expanded ? 'Ocultar datos del paciente' : 'Ver datos del paciente'}</span>
          <span
            style={{
              fontSize: 12,
              transform: expanded ? 'rotate(180deg)' : 'none',
              transition: 'transform 0.2s',
            }}
          >
            ▾
          </span>
        </button>
      )}

      {open && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
            marginTop: isMobile ? 16 : 0,
          }}
        >
          <Field label="Email">{patient.email || '-'}</Field>
          <Field label="Teléfono">{patient.phone_number || '-'}</Field>
          <Field label="Género">{genderLabel(patient.gender)}</Field>
          <Field label="Dirección">{patient.address || '-'}</Field>
          <Field label="Fecha de Nacimiento">{formatDate(patient.date_of_birth)}</Field>
          <Field label="Términos y Condiciones Aceptados">
            {formatDateTime(patient.termsAndConditionsAccepted)}
          </Field>
          <Field label="Última Actividad">{formatDateTime(patient.lastActivityAt)}</Field>
          <Field label="Versión de la App">{patient.app_version || '-'}</Field>

          {patient.serviceStatus && (
            <div>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#6b7280', marginBottom: 8, textTransform: 'uppercase' }}>
                Servicios
              </div>
              <ServiceStatusIcons status={patient.serviceStatus} size={24} gap={10} />
            </div>
          )}

          <div style={{ display: 'flex', gap: 16 }}>
            <div style={{ flex: 1 }}>
              <Field label="RMR">
                {patient.rmrKcalDay || '-'} {patient.rmrKcalDay ? 'kcal/día' : ''}
              </Field>
            </div>
            <div style={{ flex: 1 }}>
              <Field label="Peso">
                {patient.weight || '-'} {patient.weight ? 'kg' : ''}
              </Field>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PatientInfoDetails;
